// @flow
import * as React from 'react';

// A hook which ensures the referential identity of the object never changes
// Useful for tracking, as tracking is not stateful information, but relies a lot on contextual information that can't be inferred statically.
const useObject = <T: { [string]: any }>(data: T): T => {
  // Associate an object with a component
  const ref = React.useRef({});
  Object.keys(ref.current).forEach(key => {
    delete ref.current[key];
  });
  return Object.assign(ref.current, data);
};

export default useObject;
